<template>
  <div class="resource">
    <el-card class="box-card" shadow="never">
      <el-form ref="form" :inline="true" :model="form">
        <el-form-item>
          <el-input clearable v-model="form.searchKey" style="width:230px"
            placeholder="请输入资源名称" @keyup.enter.native="searchResourcePage"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchResourcePage(true)" @keyup.enter.native="searchResourcePage(true)">搜索</el-button>
        </el-form-item>
        <el-form-item v-show="auth.includes(17)">
          <el-button type="primary" @click="openAddResource">添加</el-button>
        </el-form-item>
      </el-form>

      <el-table ref="table" :data="tableData" border height="64vh" style="width: 100%;margin-top:10px;"
        :default-sort="{ prop: 'createTime', order: 'descending' }">
        <!-- <el-table-column type="index" label="序号" width="80" align="center"></el-table-column> -->
        <el-table-column prop="id" label="资源ID" width="100" align="center"></el-table-column>
        <el-table-column prop="adapterType" label="适配类型" width="80">
          <template slot-scope="{ row }">
            {{ row.adapterType | filterAdapterType }}
          </template>
        </el-table-column>
        <el-table-column prop="resourceName" label="资源名称" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="resourceNameShow" label="前端展示名称" width="180"></el-table-column>
        <el-table-column prop="resourceType" label="资源类型" sortable width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.resourceType | filterResourceType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="resourceUrl" label="资源路径"></el-table-column>
        <el-table-column prop="isH5" label="是否是h5" width="90">
          <template slot-scope="scope">
            {{ scope.row.isH5 == 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="isShow" label="是否展示" width="90">
          <template slot-scope="scope">
            {{ scope.row.isShow == 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" sortable></el-table-column>
        <el-table-column prop="status" label="状态" width="80" sortable>
          <template slot-scope="{ row }">
            <span>{{ row.status ? '正常' : '删除' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-show="auth.includes(18)" @click="openEditResource(scope.row)" type="text" size="small">修改
            </el-button>
            <el-button v-show="auth.includes(19)" @click="delUser(scope.row)" type="text" size="small">
              {{ scope.row.status == 0 ? '恢复' : '删除' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
        :page-sizes="pageList" :page-size="form.size" layout="total, sizes, prev, pager, next, jumper" :total="total"
        style="text-align: center;margin-top:20px;"></el-pagination>
    </el-card>
    <Dialog ref="dlgAddResouce" :title="dlgTitle" dlgWidth="40%">
      <el-form ref="ruleForm" :model="resourceData" label-width="135px" :rules="rules">
        <el-form-item label="父级类型" prop="parentId">
          <el-select v-model="resourceData.parentId" filterable placeholder="请选择类型" style="width:100%;">
            <el-option v-for="(item, index) in parentResourcesList" :key="index" :label="item.resourceName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适配类型" prop="adapterType">
          <el-select v-model="resourceData.adapterType" placeholder="请选择类型" style="width:100%;">
            <el-option v-for="(item, index) in adapterTypeList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="资源名称" prop="resourceName">
              <el-input placeholder="请输入" v-model="resourceData.resourceName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="前端展示名称" prop="resourceNameShow">
              <el-input placeholder="请输入" v-model="resourceData.resourceNameShow"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="资源类型" prop="resourceType">
          <el-select v-model="resourceData.resourceType" placeholder="请选择类型" style="width:100%;">
            <el-option v-for="(item, index) in resourceTypeList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否是H5" prop="isH5">
              <el-radio-group v-model="resourceData.isH5">
                <el-radio v-for="(item, index) in isNoList" :key="index" :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否展示资源名称" prop="isShow">
              <el-radio-group v-model="resourceData.isShow">
                <el-radio v-for="(item, index) in isNoList" :key="index" :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="资源路径">
          <el-input placeholder="请输入" v-model="resourceData.resourceUrl"></el-input>
        </el-form-item>
        <el-form-item label="资源编码">
          <el-input placeholder="请输入" v-model="resourceData.resourceCode"></el-input>
        </el-form-item>
        <el-form-item label="资源图片地址">
          <el-input placeholder="请输入" v-model="resourceData.resourceImageUrl"></el-input>
        </el-form-item>
        <el-form-item label="组件名称">
          <el-input placeholder="请输入" v-model="resourceData.componentName"></el-input>
        </el-form-item>
        <el-form-item label="ICON">
          <el-input placeholder="请输入" v-model="resourceData.icon"></el-input>
        </el-form-item>
        <el-form-item label="路由地址">
          <el-input placeholder="请输入" v-model="resourceData.routingAddress"></el-input>
        </el-form-item>
        <el-form-item label="资源说明">
          <el-input type="textarea" placeholder="请输入" v-model="resourceData.remark"></el-input>
        </el-form-item>
        <el-form-item style="text-align:right" class="btn-tools">
          <el-button class="btn" type="primary" @click="onSaveResource('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
  import RESOURCEAPI from '@/api/resource';
  import Dialog from '@/components/dialog';
  export default {
    components: {
      Dialog
    },
    data() {
      return {
        showTable:true,
        auth: [],
        form: {
          size: 30,
          page: 1,
          groupId: '',
          searchKey: '',
          groupId: 1
        },
        resourceData: {},
        rules: {
          parentId: [{
            required: true,
            message: '请选择类别',
            trigger: 'change'
          }],
          adapterType: [{
            required: true,
            message: '请选择类别',
            trigger: 'change'
          }],
          resourceName: [{
            required: true,
            message: '资源名称不能为空',
            trigger: 'blur'
          }],
          resourceNameShow: [{
            required: true,
            message: '资源名称不能为空',
            trigger: 'blur'
          }],
          resourceType: [{
            required: true,
            message: '资源类型不能为空',
            trigger: 'change'
          }],
          isH5: [{
            required: true,
            message: '数据不能为空',
            trigger: 'change'
          }],
          isShow: [{
            required: true,
            message: '数据不能为空',
            trigger: 'change'
          }]
        },
        dlgTitle: '添加资源',
        total: 0,
        pageList: [30, 50, 100, 150],
        tableData: [],
        adapterTypeList: [{
          label: '全部',
          value: 0
        }, {
          label: 'WEB',
          value: 1
        }, {
          label: 'APP',
          value: 2
        }],
        resourceTypeList: [{
            label: '通用',
            value: 0
          },
          {
            label: '平台',
            value: 1
          },
          {
            label: '一级指标',
            value: 2
          },
          {
            label: '二级指标',
            value: 3
          },
          {
            label: '菜单',
            value: 4
          },
          {
            label: '功能块',
            value: 5
          },
          {
            label: '按钮',
            value: 6
          },
          {
            label: '项目模块',
            value: 7
          },
          {
            label: '组织模块',
            value: 8
          }
        ],
        isNoList: [{
          label: '是',
          value: 1
        }, {
          label: '否',
          value: 0
        }],
        parentResourcesList: []
      };
    },
    filters: {
      filterAdapterType: function(v) {
        let res = '';
        switch (v) {
          case 0: {
            res = '全部';
            break;
          }
          case 1: {
            res = 'WEB';
            break;
          }
          case 2: {
            res = 'APP';
            break;
          }
        }
        return res;
      },
      filterResourceType: function(v) {
        let res = '';
        switch (v) {
          case 0: {
            res = '通用';
            break;
          }
          case 1: {
            res = '平台';
            break;
          }
          case 2: {
            break;
            res = '一级指标';
          }
          case 3: {
            res = '二级指标';
            break;
          }
          case 4: {
            res = '菜单';
            break;
          }
          case 5: {
            res = '功能块';
            break;
          }
          case 6: {
            res = '按钮';
            break;
          }
        }
        return res;
      }
    },
    methods: {
      //查看列表
      searchResourcePage(flag) {
        if(flag){
          this.form.page = 1
        }
        let params = this.form;
        
        RESOURCEAPI.searchResourcePage(params).then(res => {
          this.tableData = res.data.data.content;
          this.total = res.data.data.totalElements;
        });
      },
      //显示对话框
      showAddResource() {
        this.$refs.dlgAddResouce.open();
      },
      //打开新增资源
      openAddResource() {
        this.dlgTitle = '添加资源';
        this.$nextTick(function() {
          this.resourceData = {parentId:'',resourceType:'',resourceName:'',resourceNameShow:'',isH5:'',isShow:'',resourceUrl:'',resourceCode:'',resourceImageUrl:'',componentName:'',icon:'',routingAddress:'',remark:''};
          this.resetForm('ruleForm');
        });
        this.resourceData.adapterType = 0;
        this.showAddResource();
      },
      //打开编辑资源
      openEditResource(row) {
        this.dlgTitle = '编辑资源';
        this.resourceData = JSON.parse(JSON.stringify(row));
        this.showAddResource();
      },
      //删除用户
      delUser(row) {
        let self = this;
        this.$confirm('确定要执行此操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            RESOURCEAPI.deleteResource({
              dataId: row.id
            }).then(res => {
              this.$message.success('操作成功');
              self.searchResourcePage();
            });
          })
          .catch(() => {});
      },
      //保存新增
      saveAddResource() {
        let params = this.resourceData;
        RESOURCEAPI.addResource(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.searchResourcePage();
            this.$refs.dlgAddResouce.close();
          }
        });
      },
      //保存编辑
      saveEditResource(row) {
        RESOURCEAPI.updateResource(row).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.searchResourcePage();
            this.$refs.dlgAddResouce.close();
          }
        });
      },
      //保存资源
      onSaveResource(formName) {
        let self = this;
        let row = this.resourceData;
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (row.id) {
              //编辑
              self.saveEditResource(row);
            } else {
              //新增
              self.saveAddResource();
            }
          } else {
            return false;
          }
        });
      },
      //重置
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      //获取资源树
      searchAllResources() {
        let params = {};
        RESOURCEAPI.searchAllResources(params).then(res => {
          this.parentResourcesList = res.data.data;
        });
      },
      handleClick(row) {
      },
      handleSizeChange(val) {
        this.form.size = val;
        this.searchResourcePage();
      },
      handleCurrentChange(val) {
        this.form.page = val;
        this.searchResourcePage();
      },
    },
    created() {
      this.auth = this.COMM.getActiveAuth();
      this.searchResourcePage();
      this.searchAllResources();
    },
    mounted() {
      let self = this;
      // this.Bus.$on('onEmitCollect', (v) => {
      //   this.showTable = false;
      //   this.$nextTick(function(){
      //     this.showTable = true;
      //   })
      // })
    }
  };
</script>

<style lang="scss" scoped>
  .btn-tools {
    .btn {
      width: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/resource/index.vue